import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['replyForm', 'replyInput']

  openReply (event) {
    event.preventDefault()
    event.stopPropagation()

    this.replyFormTarget.hidden = false
    this.replyInputTarget.focus()
  }

  cancelReply (event) {
    event.preventDefault()
    event.stopPropagation()

    this.replyFormTarget.hidden = true
    this.replyFormTarget.reset()
  }
}
